import request from '@/utils/request';

export const getWeicaiPrice = (params) => {
  return request({
    url: '/api/core/v3/query_finance_info',
    method: 'get',
    params,
  })
}